// ===========================================================================
// The language a person reads messages in.
//
// The site guesses first and the person decides. Two things seen on the site
// (2026-09-15) shaped this: one person's browser said Russian and they wanted
// Ukrainian; another's said French and they wanted English. So the browser's
// language is only where the choice STARTS; the header's "Translate to"
// control changes it, the choice is remembered on this device, and a
// remembered choice beats the browser every time after. "Don't translate" is
// remembered too, as 'off'.
//
// Pure functions over the storage and navigator they are handed, so they can
// be tested without a page. ASCII only.
// ===========================================================================

export const CHAT_LANG_KEY = 'lumi.chatLang';
export const OFF = 'off';

/** 'en-GB' -> 'en'; '' for nothing. */
export function primary(tag) {
  return String(tag || '').trim().split(/[-_]/)[0].toLowerCase();
}

/**
 * What this person has chosen: a language code, OFF, or null when they have
 * not chosen yet.
 */
export function chosenLanguage(store = globalThis.localStorage) {
  try {
    const v = store?.getItem(CHAT_LANG_KEY);
    if (v === OFF) return OFF;
    const p = primary(v);
    return p || null;
  } catch {
    return null;
  }
}

/**
 * The language to read in: what they chose, else what the browser asks for,
 * else the site's own language, else English. null means "don't translate".
 *
 * @param {object} [p]
 * @param {string[]|null} [p.offered] the languages the server translates
 *   between, once known; a choice or a guess outside it still stands as the
 *   hint the partner sees ("prefers Turkish"), it simply is not translated to
 * @param {string} [p.uiLang] the language the site is being read in
 */
export function preferredLanguage({ store = globalThis.localStorage, nav = globalThis.navigator, uiLang = '' } = {}) {
  const chosen = chosenLanguage(store);
  if (chosen === OFF) return null;
  if (chosen) return chosen;
  const wanted = [nav?.language, ...(nav?.languages || []), uiLang].map(primary).filter(Boolean);
  return wanted[0] || 'en';
}

/** Remember a choice: a language code, or null for "don't translate". */
export function rememberLanguage(code, store = globalThis.localStorage) {
  try {
    store?.setItem(CHAT_LANG_KEY, code ? primary(code) : OFF);
  } catch {
    /* storage is a convenience */
  }
}

export default { preferredLanguage, chosenLanguage, rememberLanguage, primary, CHAT_LANG_KEY, OFF };
